/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { workspacesCreateWorkflow } from "../../funcs/workspacesCreateWorkflow.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequest$inboundSchema,
};

export const tool$workspacesCreateWorkflow: ToolDefinition<typeof args> = {
  name: "workspaces_create-workflow",
  description: `Create a new workflow

Creates a new workflow for a specific workspace`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await workspacesCreateWorkflow(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
